/**
 * Custom Cross-Sells AJAX Add to Cart
 * Handles button clicks for the custom cross-sells layout
 * Uses document-level event delegation to ensure it works reliably
 */
(function() {
  'use strict';

  // Use document-level event delegation
  document.addEventListener('click', function(e) {
    const button = e.target.closest('.cross-sells-custom__button');
    if (!button || button.disabled) return;

    e.preventDefault();
    e.stopPropagation();

    const box = button.closest('.cross-sells-custom__box');
    if (box) {
      handleAddToCart(box, button);
    }
  }, true);

  async function handleAddToCart(box, button) {
    const wrapper = box.closest('.cross-sells-custom-wrapper');
    const cartAction = wrapper ? wrapper.getAttribute('data-cart-action') : null;

    const originalText = button.innerHTML;
    const variantId = box.getAttribute('data-variant-id');
    if (!variantId) return;

    // Show loading state
    button.disabled = true;
    button.innerHTML = '<span class="lds-dual-ring"></span>';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      });

      if (response.ok) {
        // Show added state
        button.innerHTML = 'Added';

        // Update cart
        const cart = await (await fetch('/cart.js')).json();

        if (cartAction === 'drawer' || cartAction === 'persistent') {
          if (window.wetheme && window.wetheme.cartDrawer) {
            window.wetheme.cartDrawer.updateCartDrawer(cart);
          }
        } else {
          // Update cart count in header
          const cartCount = document.querySelector('.cart-item-count-header--quantity');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }
        }

        // Reset button after delay
        setTimeout(function() {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 2000);
      } else {
        const errorData = await response.json();
        console.error('Unable to add to cart:', errorData);
        button.innerHTML = originalText;
        button.disabled = false;
      }
    } catch (error) {
      console.error('Unable to add to cart:', error);
      button.innerHTML = originalText;
      button.disabled = false;
    }
  }
})();

